import React from "react";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";

import withSSR from "../../components/withSSR";
import DataTable from "../../components/DataTable";

import {
	getMerchantsv2,
	archiveMerchant,
	getGateway,
	getCustomSolution,
	getAccessControl,
	getResellers,
	getBaseRate,
	archiveSalesChannel,
	getBaseToAdhocPaymentMethods,
} from "../../libs/functions";

import Container from "../../components/Container";
import Util from "../../libs/util";

import CreateMerchantModal from "./components/CreateMerchantModal";
import ViewMerchantModal from "./components/ViewMerchantModal";
import ManageUserModal from "./components/ManageUserModal";
import CustomSolutionModal from "./components/CustomSolutionModal";

class Merchants extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			merchants: [],
			viewingMerchant: null,
			customList: [],
			mode: "Active",
			master: false,
			resellers: [],
			baseRate: null,
			baseToAdhocPaymentMethods: null,
		};

		this.datatableRef = React.createRef();
	}

	componentDidMount = async () => {
		if (this.props.MDRTypes) {
			this.retrieveMerchants();
			this.retrieveResellers();
		}

		this.retrieveBaseRate();
		this.retrieveBaseToAdhocPaymentMethods();
		let gateway = await getGateway();
		this.setState({ gateway: gateway });

		this.setState({ master: (await getAccessControl()) === "master" });
	};

	componentDidUpdate = (prevProps, prevState) => {
		if (!prevProps.MDRTypes) {
			if (this.props.MDRTypes) {
				this.retrieveMerchants();
				this.retrieveResellers();
			}
		}
	};

	retrieveMerchants = () => {
		this.setState({ merchants: [] });
		this.props
			.fetchData(this.container.loader, getMerchantsv2, {
				isArchive: this.state.mode !== "Active",
			})
			.then((data) => {
				this.setState({ merchants: data });
			});
	};

	retrieveResellers = async () => {
		const resellers = await getResellers();
		this.setState({
			resellers: resellers.filter((i) => i.accessControlType !== "master"),
		});
	};

	retrieveBaseRate = async (reseller) => {
		const baseRate = await getBaseRate(reseller);
		this.setState({ baseRate });
	};

	retrieveBaseToAdhocPaymentMethods = async () => {
		const baseToAdhocPaymentMethods = await getBaseToAdhocPaymentMethods();
		this.setState({ baseToAdhocPaymentMethods });
	};

	retrieveCustomSolution = async (merchant) => {
		let targetMerchant = merchant;
		if (!targetMerchant)
			targetMerchant = this.state.merchants[this.state.viewingMerchant];
		if (!targetMerchant) return;

		this.props
			.fetchData(this.container.loader, getCustomSolution, targetMerchant.id)
			.then((customList) => {
				this.setState({ customList: customList.filter((c) => !c.isArchive) });
			});
	};

	viewMerchant = (index) => {
		this.setState({ viewingMerchant: index }, async () => {
			await Util.showModal("view-merchant");
		});
	};

	manageUser = (index) => {
		this.setState({ viewingMerchant: index }, async () => {
			await Util.showModal("manage-user");
		});
	};

	configureCustomSolution = async (index) => {
		this.retrieveCustomSolution(this.state.merchants[index]);

		this.setState({ viewingMerchant: index }, async () => {
			await Util.showModal("customized-solution");
		});
	};

	toggleMode = () => {
		this.setState(
			{ mode: this.state.mode === "Active" ? "Archived" : "Active" },
			() => {
				this.retrieveMerchants();
			}
		);
	};

	archiveMerchant = (merchantId, mode = "Active", refreshViewing = false) => {
		Util.promptConfirmation().then((result) => {
			if (result.value) {
				archiveMerchant(merchantId)
					.then(async (data) => {
						if (mode === "Archived") {
							await Util.hideModal("view-merchant");
							this.setState({ mode });
						}
						this.retrieveMerchants();
					})
					.catch((err) => {
						if (err.response.status === 401) {
							Util.expireSession().then(() => {
								window.location = "/login";
							});
						}
					});
			}
		});
	};

	archive = (id) => async () => {
		try {
			// if (this.props.master) {
			const result = await Util.promptConfirmation();
			if (!result.value) return;

			const payload = { salesChannelId: id };
			const status = await this.props.fetchData(
				this.container.loader,
				archiveSalesChannel,
				payload
			);

			if (status) {
				this.retrieveCustomSolution();
				Swal.fire({
					icon: "success",
					title: `Customized Solution Archived`,
				});
			} else {
				throw new Error("Server rejected request");
			}
			// }
		} catch (err) {
			console.log(err);
			Swal.fire({
				icon: "error",
				title: `Unable to archive Customized Solution`,
			});
		}
	};

	render() {
		const { identifier, MDRTypes } = this.props;
		const {
			merchants,
			viewingMerchant,
			mode,
			gateway,
			customList,
			master,
			resellers,
			baseRate,
			baseToAdhocPaymentMethods,
		} = this.state;

		return (
			<Container ref={(c) => (this.container = c)} activeMenu={identifier}>
				<div className="Merchants">
					<div className="uk-flex uk-flex-row uk-flex-middle uk-margin-bottom">
						<h1 className="content-header uk-margin-remove-bottom">
							[{mode}] {identifier}
						</h1>
						{mode === "Active" && master && (
							<button
								className="uk-margin-left uk-icon-button uk-button-primary"
								uk-icon="icon: fa-solid-plus-circle; ratio: 0.7"
								uk-toggle="target: #create-merchant"
								type="button"
							/>
						)}
						{master && (
							<button
								className="uk-margin-auto-left uk-button uk-button-small uk-button-primary action-btn"
								type="button"
								onClick={this.toggleMode}
							>
								<span className="uk-text-middle uk-text-bold">
									View {mode === "Active" ? "Archived" : "Active"}
								</span>
							</button>
						)}
					</div>
					{merchants.length > 0 && (
						<div className="uk-card uk-card-small uk-overflow-auto uk-card-body uk-card-default">
							<DataTable
								ref={this.datatableRef}
								className="uk-table uk-table-hover uk-table-striped uk-table-middle sales-channel-table"
							>
								<thead>
									<tr>
										<th className="uk-width-1-6">Name</th>
										<th className="uk-text-center uk-width-1-6">Details</th>
										<th className="uk-text-center uk-width-1-6">Users</th>
										<th className="uk-text-center uk-width-1-6">
											Customized Solutions
										</th>
										<th className="uk-text-center uk-width-1-6">
											Transactions
										</th>
										<th className="uk-text-center uk-width-1-6">Created At</th>
										{mode === "Active" && master && (
											<th className="uk-table-shrink uk-text-center">
												Archive
											</th>
										)}
									</tr>
								</thead>
								<tbody>
									{merchants.map((merchant, index) => {
										return (
											<tr key={index}>
												<td className="uk-width-1-6">{merchant?.name}</td>
												<td className="uk-width-1-6 uk-text-center uk-text-break">
													<button
														className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
														type="button"
														onClick={() => this.viewMerchant(index)}
													>
														<span className="uk-text-middle uk-text-bold">
															View
														</span>
													</button>
												</td>
												<td className="uk-width-1-6 uk-text-center uk-text-break">
													<button
														className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
														type="button"
														onClick={() => this.manageUser(index)}
													>
														<span className="uk-text-middle uk-text-bold">
															Manage
														</span>
													</button>
												</td>
												<td className="uk-width-1-6 uk-text-center uk-text-break">
													<button
														className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
														type="button"
														onClick={() => this.configureCustomSolution(index)}
													>
														<span className="uk-text-middle uk-text-bold">
															Configure
														</span>
													</button>
												</td>
												<td className="uk-width-1-6 uk-text-center uk-text-break">
													<button
														className="uk-button uk-button-small uk-button-primary uk-width-1-1 action-btn"
														type="button"
														onClick={() =>
															this.props.history.push(
																`/transactions/${merchant?.id}`
															)
														}
													>
														<span className="uk-text-middle uk-text-bold">
															View
														</span>
													</button>
												</td>
												<td className="uk-width-1-6 uk-text-center">
													{Util.toDateTimeString(merchant?.createdAt)}
												</td>
												{mode === "Active" && master && (
													<td className="uk-text-center">
														<button
															className="uk-icon-button uk-button-danger"
															uk-icon="icon: fa-solid-archive; ratio: 0.7"
															type="button"
															onClick={() => this.archiveMerchant(merchant?.id)}
														/>
													</td>
												)}
											</tr>
										);
									})}
								</tbody>
							</DataTable>
						</div>
					)}
				</div>
				{MDRTypes && master && baseRate && (
					<CreateMerchantModal
						id="create-merchant"
						retrieveMerchants={this.retrieveMerchants}
						MDRTypes={MDRTypes}
						gateway={gateway}
						resellers={resellers}
						retrieveBaseRate={this.retrieveBaseRate}
						baseRate={baseRate}
					/>
				)}
				{MDRTypes && merchants && merchants[viewingMerchant] && (
					<div>
						<ViewMerchantModal
							id="view-merchant"
							merchant={merchants[viewingMerchant]}
							archiveMerchant={this.archiveMerchant}
							MDRTypes={MDRTypes}
							gateway={gateway}
							master={master}
							resellers={resellers}
							baseToAdhocPaymentMethods={baseToAdhocPaymentMethods}
						/>
					</div>
				)}
				{viewingMerchant !== null && (
					<div>
						<ManageUserModal
							id="manage-user"
							merchant={merchants[viewingMerchant]}
							retrieveMerchants={this.retrieveMerchants}
						/>
					</div>
				)}
				{viewingMerchant !== null && (
					<div>
						<CustomSolutionModal
							id="customized-solution"
							index={viewingMerchant}
							merchant={merchants[viewingMerchant]}
							customList={customList}
							retrieveCustomSolution={this.configureCustomSolution}
							archive={this.archive}
							master={master}
						/>
					</div>
				)}
			</Container>
		);
	}
}

export default withSSR(withRouter(Merchants));
